import { PageTypePortal } from "@/lib/types";
import { parseSafePortalCallbackUrl } from "@/lib/utils/auth/postAuthRedirect";
import { MEMBER_SETUP_ALLOWED_PATH_PREFIXES } from "./member-setup-config";

export function isMemberSetupPath(pathname: string): boolean {
  return (
    pathname === PageTypePortal.GetStarted ||
    pathname.startsWith(`${PageTypePortal.GetStarted}/`)
  );
}

export function isPathAllowedDuringMemberSetup(pathname: string): boolean {
  return MEMBER_SETUP_ALLOWED_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}

export function isPathBlockedUntilMemberSetupComplete(pathname: string): boolean {
  if (!pathname.startsWith(PageTypePortal.Dashboard)) {
    return false;
  }
  if (isMemberSetupPath(pathname)) {
    return false;
  }
  return !isPathAllowedDuringMemberSetup(pathname);
}

export function buildMemberSetupUrl(options?: {
  next?: string | null;
  source?: string | null;
}): string {
  const params = new URLSearchParams();
  if (options?.source) {
    params.set("source", options.source);
  }
  const safeNext = parseSafePortalCallbackUrl(options?.next ?? null);
  if (safeNext) {
    params.set("next", safeNext);
  }
  const query = params.toString();
  return query
    ? `${PageTypePortal.GetStarted}?${query}`
    : PageTypePortal.GetStarted;
}

export function parseMemberSetupNextParam(raw: string | null): string | null {
  return parseSafePortalCallbackUrl(raw);
}
